import { SET_CANARY_CONFIG } from '../actions/canary';

export default function reducer(state = {bucketId: ""}, action = {}) {
    if (action.type == SET_CANARY_CONFIG) {
        return {
            ...state,
            ...action.data
        };
    }

    return state;
}


// WEBPACK FOOTER //
// ./modules/Common/reducers/canary.js